import { PricingPage } from "apps/batchOnboarding/pricing/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PricingPage, "BulkPricingPage");
